import React from "react";

export default () => (
  <div className="view-header">
    <header className="title text-white">
      <h1 className="h4 text-uppercase">Payment Upload</h1>
      <p className="mb-0">Upload payment details</p>
    </header>
  </div>
);



// WEBPACK FOOTER //
// ./src/views/payment-upload/view-header.js